'use client';

import TalkToBriModalTrigger from '@/components/voice/TalkToBriModalTrigger';
import { V4_BRAND } from '@/lib/marketing/messaging-bank/v4-brand';

/**
 * HeroTalkToBriCta — the hero's primary "Talk to Bri" spark-pill CTA
 * (Homepage V5, Task B4).
 *
 * Client island so `Hero` (a Server Component) stays server-rendered for
 * LCP; this opens the shared Talk-to-Bri voice modal (`source="hero_fab"`)
 * rather than navigating anywhere or autostarting a session in the phone
 * stage — the phone's own scripted demo (`HeroPhoneDemo`) is fully separate
 * theater, never a live ElevenLabs session.
 */
export function HeroTalkToBriCta() {
  return (
    <div className="hv-cta-wrap">
      <span className="hv-cta-caption" aria-hidden="true">
        {V4_BRAND.heroCtaCaption}
      </span>
      <div className="hv-cta-inner">
        <div className="hv-cta-particles" aria-hidden="true">
          <span className="hv-spark hv-spark-cyan" data-i="0" />
          <span className="hv-spark hv-spark-amber" data-i="1" />
          <span className="hv-spark hv-spark-jade" data-i="2" />
          <span className="hv-spark hv-spark-cyan" data-i="3" />
          <span className="hv-spark hv-spark-amber" data-i="4" />
          <span className="hv-spark hv-spark-jade" data-i="5" />
        </div>
        <TalkToBriModalTrigger source="hero_fab">
          {(open) => (
            <button
              type="button"
              onClick={open}
              className="hv-cta-btn"
              aria-label={`${V4_BRAND.fabLabel} — start a live voice demo`}
              data-testid="hero-cta-talk-to-bri"
            >
              <span className="hv-cta-dot" aria-hidden="true" />
              <span className="hv-cta-copy">
                <span className="hv-cta-label">{V4_BRAND.fabLabel}</span>
              </span>
              <svg
                className="hv-cta-mic"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"
                  fill="currentColor"
                  stroke="none"
                />
                <path
                  d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
                  fill="currentColor"
                  stroke="none"
                />
              </svg>
            </button>
          )}
        </TalkToBriModalTrigger>
      </div>
    </div>
  );
}

export default HeroTalkToBriCta;
